/////////////
//// スライド
if (document.querySelector('#slide')) {
  const slide_prev = document.querySelector('#slide').querySelector('.swiper-button-prev');
  const slide_next = document.querySelector('#slide').querySelector('.swiper-button-next');
  const slide_page = document.querySelector('#slide').querySelector('.swiper-pagination');
  const swiper = new Swiper('.swiper1', {
    loop: true,
    speed: 500,
    pagination: {
      el: ".swiper-pagination",
      el: slide_page,
      clickable: true,
    },
    navigation: {
      // nextEl: '.swiper1 .swiper-button-next',
      // prevEl: '.swiper1 .swiper-button-prev',
      nextEl: slide_next,
      prevEl: slide_prev,
    },
     autoplay: {
       delay: 3000,
     },
    spaceBetween: 24,
    slidesPerView: 1,
    centeredSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 1.2
      }
    }
  });
}
// スライド2
if (document.querySelector('#slide2')) {
  const slide2_prev = document.querySelector('#slide2').querySelector('.swiper-button-prev');
  const slide2_next = document.querySelector('#slide2').querySelector('.swiper-button-next');
  const swiper2 = new Swiper('.swiper2', {
    speed: 500,
    navigation: {
      nextEl: slide2_next,
      prevEl: slide2_prev,
    },
    // autoplay: {
    //   delay: 3000,
    // },
    slidesPerView: 2,
    spaceBetween: 0,
    breakpoints: {
      768: {
        slidesPerView: 3,
      }
    },
  });
}


/////////////
/// 「スマホのカテゴリから探すのアコーディオン
// メニューを開く関数


  //アコーディオン
jQuery(function($) {
  function toggleAccordion() {
    var windowWidth = $(window).width();
    if (windowWidth < 768) {
      $('.js-accordion-title').off('click'); // 既存のクリックイベントを一旦解除する
      $('.js-accordion-title').removeClass('open');
      $('.accordion__content').slideUp();
      $('.js-accordion-title').click(function() {
        if ($(this).hasClass('open')) { // クリックした要素が既に開いている場合
          $(this).removeClass('open');
          $(this).next('.accordion__content').slideUp();
        } else { // クリックした要素が閉じている場合
          $('.js-accordion-title').removeClass('open');
          $('.accordion__content').slideUp();
          $(this).addClass('open');
          $(this).next('.accordion__content').slideDown();
        }
      });
    } else {
      $('.js-accordion-title').addClass('open');
      $('.accordion__content').slideDown();
      $('.js-accordion-title').off('click');
    }
  }

  toggleAccordion();

  $(window).on('resize', function() {
    toggleAccordion();
  });
});


  /////////////
  /// ヘッダーの高さを変える
  var headerH = $(".header").outerHeight(true);//headerの高さを取得

//スクロール途中からヘッダーの高さを変化させるための設定を関数でまとめる
function FixedAnime() {
	//ヘッダーの高さを取得
	var scroll = $(window).scrollTop();
	if (scroll >= headerH){//ヘッダーの高さを超えたら
        $('.header').addClass('heightMin');//#headerについているHeightMinというクラス名を付与
	}else{
        $('.header').removeClass('heightMin');//HeightMinというクラス名を除去
	}
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
	FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});


/////////////
/// サムネイルをクリックしてメイン画像を切り替え
  jQuery(function () {
  $(".js-sub-img img").on("click", function () {
    // メイン画像に切り替えるimgのsrc取得
    img = $(this).attr("src");
    // currentクラス付け替え(枠線などを変えたい時に)
    $(".js-sub-img li").removeClass("active-thumb");
    $(this).parent().addClass("active-thumb");
     $(".js-main-img img").attr("src", img);
    // fadeOutできたらsrc変更してfadeIn
//    $(".js-main-img img").fadeOut(500, function () {
  //    $(".js-main-img img")
  //      .attr("src", img)
  //      .on("load", function () {
  //        $(this).fadeIn(500);
  //      });
  //  });
  });
});



/////////////
/// 「もっと見る」ボタン押下で11個目以降のカテゴリが表示される
const elements = document.querySelectorAll('.morebox');
Array.from(elements).forEach(function(el){

    //ボタンを取得
    const btn = el.querySelector('.more__btn');
    //コンテンツを取得
    const content = el.querySelector('.more__content');
    // 最初に表示させるliの数
    let num = 10;

    // liの数を取得
    const listItems = $(".morebox li").length;
    // 初期表示数以降のリスト内容を非表示に
    $(".morebox li:nth-child(n+" + (num+1) + ")").hide();


    //初期表示数以下であればMoreボタンを非表示
    $(".morebox").filter(function(){
        return $(this).find("li").length <= num
    }).find(".more__btn").hide();


    //ボタンクリックでイベント発火
    btn.addEventListener('click', function(){

        if(!content.classList.contains('open')){
            //コンテンツの実際の高さを代入
            //キーワード値（none、max-content等）では動作しないので注意
            //content.style.maxHeight = content.scrollHeight + 'px';
            let this_list = $(this).closest(".morebox")
            this_list.find("li:hidden").show()

            //openクラスを追加
            content.classList.add('open');
            btn.classList.add('changes');
            //もっと見るボタンのテキストを設定
            btn.textContent = '閉じる';
        } else {
            //コンテンツの高さを固定値を代入
            //content.style.maxHeight = '240px';
            let this_list = $(this).closest(".morebox")
            this_list.find("li:not(:lt(" + num + "))").hide();
            //openクラスを削除
            content.classList.remove('open');
            btn.classList.remove('changes');
            //もっと見るボタンのテキストを設定
            btn.textContent = 'もっと見る';
        }
    });
});


/////////////////////////////////////////////////////
//横スクロール ネット(農業用)のオプション加工 sp
$(function() {
    var leftbutton = $('.detail_option .scrl_btn_prev');
    var rightbutton = $('.detail_option .scrl_btn_next');
        //右へ
        rightbutton.click(function () {
        $('.detail_option_wrapper').animate({
            scrollLeft: $('.detail_option_wrapper').scrollLeft() + 280
        }, 300);
        return false;
        });
        //左へスクロールで表示
        $('.detail_option_wrapper').scroll(function () {
            if($(this).scrollLeft() < $('.table_scroll').width() - $('.detail_option_wrapper').width()) {
                rightbutton.fadeIn();
            } else {
                rightbutton.fadeOut();
            }
        });
        //左へ
        leftbutton.click(function () {
        $('.detail_option_wrapper').animate({
            scrollLeft: $('.detail_option_wrapper').scrollLeft() - 280
        }, 300);
        return false;
        });
        //右へスクロールで表示
        leftbutton.hide();
        $('.detail_option_wrapper').scroll(function () {
            if($(this).scrollLeft() > 0) {
                leftbutton.fadeIn();
            } else {
                leftbutton.fadeOut();
            }
        });
  });

/////////////////////////////////////////////////////
//横スクロール 表バージョン
$(function() {
    var leftbutton2 = $('.detail_items_table_scroll .scrl_btn_prev');
    var rightbutton2 = $('.detail_items_table_scroll .scrl_btn_next');
        //右へ
        rightbutton2.click(function () {
        $('.idetailspe_container').animate({
            scrollLeft: $('.idetailspe_container').scrollLeft() + 280
        }, 300);
        return false;
        });
        //左へスクロールで表示
        $('.idetailspe_container').scroll(function () {
            if($(this).scrollLeft() < $('.deitgr_cap_table').width() - $('.idetailspe_container').width()) {
                rightbutton2.fadeIn();
            } else {
                rightbutton2.fadeOut();
                leftbutton2.fadeIn();
            }
        });
        //左へ
        leftbutton2.click(function () {
        $('.idetailspe_container').animate({
            scrollLeft: $('.idetailspe_container').scrollLeft() - 280
        }, 300);
        return false;
        });
        //右へスクロールで表示
        leftbutton2.hide();
        $('.idetailspe_container').scroll(function () {
            if($(this).scrollLeft() > 0) {
                leftbutton2.fadeIn();
            } else {
                leftbutton2.fadeOut();
              rightbutton2.fadeIn();
            }
        });
  });

  /////////////////////////////////////////////////////
  //横スクロール ドラッグ
//   jQuery.prototype.mousedragscrollable = function () {
//   let target;
//   $(this).each(function (i, e) {
//     $(e).mousedown(function (event) {
//       event.preventDefault();
//       target = $(e);
//       $(e).data({
//         down: true,
//         move: false,
//         x: event.clientX,
//         y: event.clientY,
//         scrollleft: $(e).scrollLeft(),
//         scrolltop: $(e).scrollTop(),
//       });
//       return false;
//     });
//     $(e).click(function (event) {
//       if ($(e).data("move")) {
//         return false;
//       }
//     });
//   });
//   $(document)
//     .mousemove(function (event) {
//       if ($(target).data("down")) {
//         event.preventDefault();
//         let move_x = $(target).data("x") - event.clientX;
//         let move_y = $(target).data("y") - event.clientY;
//         if (move_x !== 0 || move_y !== 0) {
//           $(target).data("move", true);
//         } else {
//           return;
//         }
//         $(target).scrollLeft($(target).data("scrollleft") + move_x);
//         $(target).scrollTop($(target).data("scrolltop") + move_y);
//         return false;
//       }
//     })
//     .mouseup(function (event) {
//       $(target).data("down", false);
//       return false;
//     });
// };
// $(".sp_tablesclx_wrap").mousedragscrollable();

//ランキング　表示崩れ

